import { clientWithApiClient } from "../../client";
import type { ApiClient } from "../../types";
import type {
  VehicleDeliveryLocation,
  CreateDeliveryLocationRequest,
  DeliveryLocationsResponse,
  DeliveryLocationResponse,
} from "./types";

/**
 * List all delivery locations for a vehicle
 * GET /v1/vehicles/:vehicleId/delivery-locations
 */
const list = (apiClient: ApiClient, vehicleId: string) =>
  clientWithApiClient<DeliveryLocationsResponse>(
    apiClient,
    `/vehicles/${vehicleId}/delivery-locations`,
  );

/**
 * Create a new delivery location for a vehicle
 * POST /v1/vehicles/:vehicleId/delivery-locations
 */
const create = (
  apiClient: ApiClient,
  vehicleId: string,
  data: CreateDeliveryLocationRequest,
) =>
  clientWithApiClient<DeliveryLocationResponse>(
    apiClient,
    `/vehicles/${vehicleId}/delivery-locations`,
    {
      method: "POST",
      body: JSON.stringify({ delivery_location: data }),
    },
  );

/**
 * Delete (soft delete) a delivery location
 * DELETE /v1/delivery-locations/:locationId
 */
const deleteLocation = (apiClient: ApiClient, locationId: string) =>
  clientWithApiClient<void>(apiClient, `/delivery-locations/${locationId}`, {
    method: "DELETE",
  });

export const vehicleDeliveryLocations = {
  list,
  create,
  delete: deleteLocation,
};
